import { CalendarDate, parseDate } from "@internationalized/date";

type UpcomingAppointmentCandidate = {
  isDeleted: boolean;
  appointment: {
    isDeleted: boolean;
    isSubscriptionVisitEventOnly: boolean;
    startTimeUtc: Date | string;
    startTimeLocal: string;
    service: { serviceId: number };
  };
};

export type FirstUpcomingCoveredAppointment<T> = {
  date: CalendarDate;
  customerAppointment: T;
};

export function getFirstUpcomingCoveredAppointment<
  T extends UpcomingAppointmentCandidate,
>({
  customerAppointments,
  serviceIds,
  now,
}: {
  customerAppointments: T[];
  serviceIds: number[];
  now: Date;
}): FirstUpcomingCoveredAppointment<T> | null {
  if (serviceIds.length === 0) {
    return null;
  }

  const coveredServiceIds = new Set(serviceIds);

  const firstAppointment = customerAppointments
    .filter(
      (customerAppointment) =>
        !customerAppointment.isDeleted &&
        !customerAppointment.appointment.isDeleted &&
        !customerAppointment.appointment.isSubscriptionVisitEventOnly &&
        coveredServiceIds.has(
          customerAppointment.appointment.service.serviceId,
        ) &&
        new Date(customerAppointment.appointment.startTimeUtc) > now,
    )
    .toSorted(
      (a, b) =>
        new Date(a.appointment.startTimeUtc).getTime() -
        new Date(b.appointment.startTimeUtc).getTime(),
    )[0];

  if (!firstAppointment) {
    return null;
  }

  // startTimeLocal is already in the location's time zone, so its date part is the training day.
  return {
    date: parseDate(firstAppointment.appointment.startTimeLocal.slice(0, 10)),
    customerAppointment: firstAppointment,
  };
}
